
(() => {
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.sectionId = this.dataset.sectionId;
      if (!this.form) return;

      this.debouncedSubmit = window.ThemeUtils.debounce(() => this.apply(), 400);

      this.form.addEventListener('change', (e) => {
        if (e.target.matches('input[type="number"], input[type="text"]')) this.debouncedSubmit();
        else this.apply();
      });
      this.form.addEventListener('input', (e) => {
        if (e.target.matches('input[type="number"], input[type="text"]')) this.debouncedSubmit();
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(); });

      this.addEventListener('click', (e) => {
        const clear = e.target.closest('[data-facet-clear]');
        if (!clear) return;
        e.preventDefault();
        this.apply(clear.dataset.facetClear || clear.getAttribute('href'));
      });

      this.onPopState = () => this.apply(window.location.search, { push: false });
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
    }

    async apply(urlOverride, { push = true } = {}) {
      const search = urlOverride
        ? new URL(urlOverride, window.location.origin).search
        : `?${new URLSearchParams(new FormData(this.form)).toString()}`;

      const params = new URLSearchParams(search);
      params.delete('page'); 
      const query = params.toString();

      this.setLoading(true);
      try {
        const url = `${window.location.pathname}?${query}`;
        const res = await fetch(`${url}${query ? '&' : ''}section_id=${this.sectionId}`);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const pairs = [];
        ['[data-facet-results]', '[data-facet-filters]', '[data-facet-count]'].forEach((sel) => {
          const freshAll = doc.querySelectorAll(sel);
          document.querySelectorAll(sel).forEach((current, i) => {
            if (freshAll[i]) pairs.push([current, freshAll[i]]);
          });
        });

        pairs.forEach(([current, fresh]) => {
          if (!current.isConnected) return; 
          const openState = Array.from(current.querySelectorAll('details')).map((d) => d.open);
          fresh.querySelectorAll('details').forEach((d, di) => {
            if (openState[di] !== undefined) d.open = openState[di];
          });
          current.replaceWith(fresh);
        });

        if (push) window.history.pushState({ facets: true }, '', url);
        document.querySelector('[data-facet-results]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        console.error('[facets] apply failed', e);
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(on) {
      document.querySelector('[data-facet-results]')?.classList.toggle('is-loading', on);
      this.classList.toggle('is-loading', on);
    }
  }

  if (!customElements.get('facet-filters')) customElements.define('facet-filters', FacetFilters);

  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-sort-form]');
    if (!form) return;
    const facets = document.querySelector('facet-filters');
    if (!facets || typeof facets.apply !== 'function') return;   
    e.preventDefault();
    facets.apply(`?${new URLSearchParams(new FormData(form)).toString()}`);
  });

  document.addEventListener('submit', (e) => {
    if (e.target.matches('[data-sort-form]') && document.querySelector('facet-filters')) {
      e.preventDefault();
    }
  });
})();
